const initialState = {
  latestSearch: {
    params: null, // { query: string, proximity: [number, number] },
    features: null,
  },
};

const Actions = {
  SUGGESTIONS_CHANGED: 'search/suggestions-changed',
  FOCUSED_CHANGED: 'search/focused-changed',
};

const suggestionsChanged = ({ params, features }) => ({
  type: Actions.SUGGESTIONS_CHANGED,
  params,
  features,
});

const focusedChanged = (focused) => ({
  type: Actions.FOCUSED_CHANGED,
  focused,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case Actions.SUGGESTIONS_CHANGED:
      return {
        ...state,
        latestSearch: {
          params: action.params,
          features: action.features,
        },
      };
    case Actions.FOCUSED_CHANGED:
      return {
        ...state,
        focused: action.focused,
      };
  }
  return state;
}

function selectSuggestedFeatures(state) {
  return state.search.latestSearch.features;
}

function selectSearchParams(state) {
  return state.search.latestSearch.params;
}

function selectFocused(state) {
  return state.search.focused;
}

export {
  reducer,
  suggestionsChanged,
  focusedChanged,
  selectSuggestedFeatures,
  selectSearchParams,
  selectFocused,
};
